var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c28eymoe6a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.478431 0 0 0 0 0.478431 0 0 0 0 0.478431 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-38 -1596) translate(0 1400) translate(38 104) translate(0 89)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    className: "icon-fill",
    fill: "#7A7A7A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.556.444v7.11l3.464.001c.355 0 .557.388.382.673l-.047.064-5.243 5.992c-.176.203-.492.203-.669 0L.2 8.292c-.251-.287-.047-.737.336-.737H4V.444h3.556z",
    transform: "translate(0 3) translate(1.333 2) matrix(1 0 0 -1 4.889 14.667) matrix(1 0 0 -1 0 14.88)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "icon-stroke",
    stroke: "#7A7A7A",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.444 14.222L0 16 10.667 19.556 21.333 16 16.889 14.222",
    transform: "translate(0 3) translate(1.333 2)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDelivery);
export default __webpack_public_path__ + "static/media/new-delivery.23486992bf6b0690a3f93f923a9974ce.svg";
export { ForwardRef as ReactComponent };